import { createContext } from 'react';

export const imageSizeContext = createContext();
